import React from 'react';
import {styled} from '@netx/core-components/Theme';
import Alert, {AlertProps} from '../Alert';

const DialogAlertRoot = styled(Alert, {
	name: 'DialogAlert',
	slot: 'Root',
})(({theme}) => ({
	margin: theme.spacing(1, 2, 2, 2),
}));

export interface DialogAlertProps extends AlertProps {}

/** NetX Dialog Alert */
const DialogAlertPrimitive = React.forwardRef<HTMLDivElement, DialogAlertProps>(
	(props, ref) => <DialogAlertRoot ref={ref} severity="error" {...props} />,
);

export const DialogAlert = React.memo(DialogAlertPrimitive);
export default DialogAlert;
